import { createContext, MutableRefObject, ReactNode, RefObject, useContext, useRef } from "react";

const LabelingContext = createContext<{ isLabelingRef: MutableRefObject<boolean> } | null>(null);

export const LabelingProvider = ({ children }: { children: ReactNode }) => {
  const isLabelingRef = useRef(false);
  return <LabelingContext.Provider value={{ isLabelingRef }}>{children}</LabelingContext.Provider>;
};

export const useLabeling = () => {
  const ctx = useContext(LabelingContext);
  if (!ctx) throw new Error("LabelingProvider 필요");
  return ctx;
};
